export default "__VITE_ASSET__a7a19752__"